import {Component, Input, OnInit} from '@angular/core';
import {MenuItem} from '../../../../interfaces/data.interfaces';
import {OwnerTypeEnum} from '../../../../enums/data.enums';
import {Observable} from 'rxjs';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {map, shareReplay} from 'rxjs/operators';

@Component({
    selector: 'app-portal-layout',
    templateUrl: './portal-layout.component.html',
    styleUrls: ['./portal-layout.component.scss'],
    standalone: false
})
export class PortalLayoutComponent implements OnInit{

  @Input() moduleTitle: string;
  @Input() ownerType: OwnerTypeEnum;
  @Input() menuItems: MenuItem[];
  @Input() moduleIconType: 'SVG' | 'MATERIAL';
  @Input() moduleIconTitle: string;

  ownerTypeEnum = OwnerTypeEnum;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(private breakpointObserver: BreakpointObserver) {}

  ngOnInit() {
  }

}
